/* eslint-disable no-unused-vars */
export default {
  state: {
    googleObj: {
      googleId: '',
      nome: '',
      email: '',
      foto: ''
    }
  },
  mutations: {
    setGoogleObj(state, payload) {
      state.googleObj = payload
      //console.log("mutation", state.googleObj = payload)
    }
  },
  actions: {
    actGoogleObj({ commit }, payload) {

      commit('setGoogleObj', payload)
      //console.log("action", commit, payload)
    },
  },
  getters: {
    getGoogleObj(state) {
      //console.log("getter", state.googleObj)
      return state.googleObj
    }
  }
}
